
import getPromiseCallback from '../../common/client/utils/getPromiseCallback';

import { callGet } from '../../common/client/serverApi/funcs';

export function getArticleList(action) {
    return new Promise((resolve, reject) => {
        callGet({
            baseUrl: '/service',
            module: 'portal',
            name: 'GetArticleList',
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}
